<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit"></searchForm>
		<Table :columns="columns1" :data="data" :height="tableHeight" size="small">
			<MyPage slot="footer" ref="sonPage" :param="SelectParam" :url="getSysWidgetsUrl" @listData='getDeviceData'></MyPage>
		</Table>
		<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal>
		<!-- <DistributeModal  ref="distributeModal"></DistributeModal> -->
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi';
	import searchForm from './Template/ControlForm.vue';
	import infoModal from './Template/ControlModal.vue';
	// import DistributeModal from './Template/DistributeModal.vue';
	export default {
		components: {
			searchForm,
			infoModal,
			// DistributeModal
		},
		data() {
			return {
				getSysWidgetsUrl: webapi.base_api_url + '/System/GetSysWidgets',
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: [this.$tt('系统管理'), '>>', this.$tt('控件管理')],
				//table标题数据
				columns1: [
					// {
					// 	title: 'ID',
					// 	key: 'Id',
					// 	width: 100
					// }, 
					{
						title: this.$tt('控件名称'),
						key: 'Name',
						minWidth: 100,
					},
					{
						title: this.$tt('显示名称'),
						key: 'Display',
						minWidth: 120,
					},
					{
						title: this.$tt('控件描述'),
						key: 'Desc',
						minWidth: 120,
					},
					{
						title: this.$tt('控件图标'),
						key: 'Icon',
						minWidth: 100,
					},
					{
						title: this.$tt('是否删除'),
						key: 'IsDeleted',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.IsDeleted == 1 ? '是' : '否')
						}
					},
					{
						title: this.$tt('控件类型'),
						key: 'WidgetType',
						minWidth: 100,
						render: (h, params) => {
							let typeDesc = ''
							switch (params.row.WidgetType) {
								case 1:
									typeDesc = 'buttons'
									break;
								case 2:
									typeDesc = 'tableBar'
									break;
								case 3:
									typeDesc = 'foem';
									break;
								default:
									break;
							}
							return h('div', typeDesc)
						}
					},
					{
						title: this.$tt('是否告警'),
						key: 'IsDanger',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.IsDanger == 1 ? '是' : '否')
						}
					},
					{
						title: this.$tt('排序'),
						key: 'Sort',
						minWidth: 100,
					},
					{
						title: this.$tt('修改者'),
						key: 'Modifier',
						minWidth: 100,
					}, {
						title: this.$tt('修改时间'),
						key: 'ModifyTime',
						minWidth: 100,
					},
					{
						title: this.$tt('操作'),
						key: 'action',
						align: 'center',
						minWidth: 180,
						render: (h, params) => {
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show('up', params.row)
										}
									}
								}, this.$tt('修改')),
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		click: () => {
								// 			this.show('distribute', params.row.Id)
								// 		}
								// 	}
								// }, this.$tt('分配站点')),
								h('Dropdown', {
										on: {
											//为了不误操作，确定取消相反
											'on-click': (name) => {
												this.$Modal.confirm({
													title: name,
													okText: this.$tt('取消'),
													cancelText: this.$tt('确定'),
													onCancel: () => {
														this.otherMethodStation(name,
															params.row.Id);
													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, this.$tt('其他操作')),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.map((
											item) => { // this.productTypeList下拉框里的data
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								)
							]);
						}
					}
				],

				data: [],
				widgetTotalNum: 0,
				methodList: [{
					Id: 0,
					Status: this.$tt('正常')
				}, {
					Id: 1,
					Status: this.$tt('删除')
				}, ]
			}
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 160;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			//删除修改之外的其他操作
			otherMethodStation: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).Id
				this.$axios.post(webapi.base_api_url + "/System/SetSysWidgetStatus ", {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.info(name + this.$tt('成功'));
						this.handleSubmit();
					}
				})
			},
			/******************组件固定方法*************************/
			show: function(type, params) {
				switch (type) {
					case 'up':
						this.$refs.ItemModal.show(type, params, this.widgetTotalNum)
						break;
					case 'add':
						this.$refs.ItemModal.show(type, params, this.widgetTotalNum + 1)
						break;
						// case 'distribute':
						// this.$refs.DistributeModal.show(type, params)
						// break;
				}
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
				this.widgetTotalNum = data.Total
			},
			handleSubmit: function() {
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160;
			},
		},
	}
</script>

<style>
</style>
